<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <h2 *ngIf="currentItem?.displayName">{{ currentItem?.displayName }} [{{ currentItem?.code }}]</h2>
      </div>
      <div class="div-btns-top">
        <action-bar
          [showSave]="!isFormDisable()"
          [showAddToFavorites]="!favoriteId && currentItem && currentItem.resourceId"
          [showRemoveFromFavorites]="favoriteId"
          [showDuplicate]="!!currentItem?.canDuplicate"
          [showDelete]="manageTransports && (currentItem?.canUpdate == true || !currentItem?.resourceId) && currentItem?.resourceId"
          (onSave)="clickSave(form?.value)"
          (onAddToFavorites)="addToFavorite(currentItem.resourceId!)"
          (onRemoveFromFavorites)="removeFromFavorite()"
          (onDuplicate)="clickDuplicate()"
          (onDelete)="openDialogDelete(currentItem.resourceId)"></action-bar>
      </div>
    </div>
    <div>
      <div class="identification">
        <h3 class="title-margin-top">{{ 'common_section_identification' | translate }}</h3>
        <mat-card [class]="{ 'disabled-form': isFormDisable() }">
          <mat-grid-list cols="10" rowHeight="60px" gutterSize="20px">
            <mat-grid-tile colspan="2">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
                <input matInput formControlName="code" minlength="2" maxlength="9" required />
                <mat-error *ngIf="formCrls.code.invalid">{{ 'ref_error_code_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <mat-form-field>
                <mat-label>{{ 'common_field_label' | translate }}</mat-label>
                <input matInput formControlName="displayName" required />
                <mat-error *ngIf="formCrls.displayName.invalid">{{ 'ref_error_label_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_owner' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.owner.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_creator' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.creator.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>
      <div>
        <h3 class="title-margin-top">{{ 'transport_section' | translate }}</h3>
        <mat-card [class]="{ 'disabled-form': isFormDisable() }">
          <mat-grid-list cols="10" rowHeight="75px" gutterSize="50px">
            <mat-grid-tile colspan="3">
              <mat-form-field>
                <mat-label color="accent">{{ 'ref_field_family' | translate }}</mat-label>
                <mat-select formControlName="familyId">
                  <mat-option *ngFor="let x of families" [value]="x.familyId"> {{ x.displayName }}</mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="6">
              <mat-form-field>
                <mat-label>{{ 'common_field_description' | translate }}</mat-label>
                <textarea matInput rows="2" formControlName="description"></textarea>
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
          <mat-grid-list cols="10" rowHeight="75px" gutterSize="50px" *ngIf="acuView && form.value.familyId !== familyRoutierId">
            <mat-grid-tile colspan="9">
              <mat-form-field>
                <mat-label>{{ 'transport_field_energy_description' | translate }}</mat-label>
                <textarea matInput rows="1" formControlName="energieDescription" maxlength="100"></textarea>
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>

      <div class="version col-6" *ngIf="currentItem.resourceId && currentItem.ruade">
        <h3 class="title-margin-top" style="opacity: 0.8">{{ 'ref_section_db_version' | translate }}</h3>
        <!-- <h3 class="title-margin-top">Version de la base de données</h3> -->
        <mat-card>
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <mat-label>{{ 'ref_field_choose_version' | translate }}</mat-label>
                <mat-select [multiple]="false" formControlName="versionId" (selectionChange)="onVersionChange($event.value)">
                  <mat-option *ngFor="let p of dbVersions" [value]="p.versionId">
                    {{ p.versionName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>

      <div formGroupName="ceu">
        <h3 class="title-margin-top">{{ 'transport_section_env_cost_tkm' | translate }}</h3>
        <mat-card>
          <mat-grid-list cols="12" rowHeight="60px" gutterSize="40px">
            <mat-grid-tile colspan="3" [class]="{ 'disabled-form': isFormDisable() }">
              <mat-form-field>
                <mat-label color="accent">{{ 'ref_field_energy_mj' | translate }}</mat-label>
                <input matInput type="number" formControlName="en" required [disabled]="isFormDisable()" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3" [class]="{ 'disabled-form': isFormDisable() }">
              <mat-form-field>
                <mat-label color="accent">{{ 'transport_field_ges' | translate }}</mat-label>
                <input matInput type="number" formControlName="co" required [disabled]="isFormDisable()" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <div class="justificatif" *ngIf="!isFormDisable()" [matTooltip]="!currentItem?.resourceId ? ('ref_save_before_add_proof' | translate) : ''">
                <input id="singleFile" type="file" #proofUpload class="inputfile" accept="application/pdf" (change)="uploadProof(currentItem?.resourceId, proofUpload.files)" #fileInput [disabled]="!currentItem?.resourceId" />
                <button mat-mini-fab color="accent" class="mini-fab" (click)="fileInput.click()" [disabled]="!currentItem?.resourceId">
                  <mat-icon>add</mat-icon>
                </button>
                <label [class.cursor]="currentItem?.resourceId" [attr.for]="currentItem?.resourceId ? 'singleFile' : null">{{ 'ref_add_proof_pdf' | translate }}</label>
              </div>
            </mat-grid-tile>
            <mat-grid-tile colspan="3" *ngIf="form.value.fileName">
              <div class="justificatif">
                <button mat-mini-fab color="warn" class="mini-fab" (click)="deleteFile()">
                  <mat-icon>delete_outline</mat-icon>
                </button>
                <a [href]="currentItem.resourceId ? justificationFilePath + form.value.fileDescription : form.value.fileDescription" target="_blank">{{ form.value.fileName }} </a>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>
    </div>
  </form>
</div>
